import { Button } from '@warp-ds/react';
import { trackDigitalContractClick } from '@/lib/tracking/tracking';
import { replacePropsWithPreview } from '../../utils';

export type DigitalContractProps = {
    adId: number;
    isPreview?: boolean;
};

export const DigitalContract = ({ adId, isPreview = false }: DigitalContractProps) => {
    const digitalContractUrl = `https://swiftcourt.com/no/finn-vacation-rental?finn_id=${adId}`;

    return (
        <>
            <ul className="list-checked mb-16">
                <li>Utfylt kontrakt med opplysninger fra annonsen</li>
                <li>Signer kontrakten elektronisk</li>
                <li>Gratis tjeneste</li>
            </ul>
            <Button
                fullWidth
                rel="noopener noreferrer nofollow external"
                target="_blank"
                {...replacePropsWithPreview(
                    {
                        href: digitalContractUrl,
                        onClick: () => trackDigitalContractClick(digitalContractUrl),
                    },
                    isPreview,
                )}
                data-testid="digitalContract">
                Opprett digital leiekontrakt
            </Button>
        </>
    );
};
